import { getLintRulesBasedOnContext as CE_getLintRulesBasedOnContext } from "ce/utils/lintRulesHelpers";

import { IDE_TYPE, type IDEType } from "ee/IDE/Interfaces/IDETypes";

interface ContextType {
  ideType: IDEType;
}

/**
 * Function used to conditionally enable/disable custom rules based on context provided
 *
 * @returns {Record<string, "off"|"error">} Object with settings for the rule
 * */
export const getLintRulesBasedOnContext = ({
  ideType,
}: ContextType): Record<string, "off" | "error"> => {
  const extraRules: Record<string, "off" | "error"> = {};

  if (ideType === IDE_TYPE.Workflow) {
    extraRules["customRules/no-floating-promises"] = "error";
  }

  return { ...CE_getLintRulesBasedOnContext, ...extraRules };
};
